import React from 'react';
import styled from 'styled-components';
import { getBreakpointFromProps } from './utils';
import { Breakpoint, MediaProps } from './types';
import { breakpoints } from './constants';

const HideBelowWrapper = styled.div<{
    breakpoint: Breakpoint;
}>`
    display: block;

    @media (max-width: ${({ breakpoint }) => breakpoints[breakpoint]}px) {
        display: none;
    }
`;

const HideBelow = (props: MediaProps & { children?: React.ReactNode }) => {
    const { children } = props;

    return (
        <HideBelowWrapper breakpoint={getBreakpointFromProps(props)}>
            {children}
        </HideBelowWrapper>
    );
};

export default HideBelow;
